export * from './chargepoint-details-page'
